import { ReactNode } from 'react';
import { Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { Back } from '../../common';
import { DashboardRoutesConfig } from '../../dashboard';
import { TASK_CONTENT_MAX_WIDTH } from '../consts';

interface Props {
  title: string;
  children: ReactNode;
}

export function TaskPage({ title, children }: Props): JSX.Element {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.container)}>
      <div className={classes.content}>
        <Back
          link={DashboardRoutesConfig.dashboard.generatePath()}
          className={classes.back}
        />

        <Paper className={classes.card}>
          <Typography className={classes.title} variant="h5">
            {title}
          </Typography>

          {children}
        </Paper>
      </div>
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
  },

  content: {
    '&&': {
      width: '100%',
      maxWidth: TASK_CONTENT_MAX_WIDTH,
    },
  },

  card: {
    '&&': {
      width: '100%',
      padding: theme.spacing(15),

      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(15, 8),
      },

      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(8, 4),
      },
    },
  },

  title: {
    textAlign: 'center',

    [theme.breakpoints.down('sm')]: {
      wordBreak: 'break-all',
    },
  },

  back: {
    marginBottom: theme.spacing(8),
  },
}));
